import React from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const Hero = ({ title }) => {
  return (
    <>
      {/* Hero unit */}
      <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 5 }}>
        <Typography
          component="h1"
          variant="h3"
          align="center"
          color="text.primary"
          gutterBottom
        >
          {title}
        </Typography>
      </Container>
      {/* End hero unit */}
    </>
  );
};

export default Hero;
